import StatsCard from "../StatsCard";

const Stats = ({ stats, showCurrency = true, isLoading = false }) => {
  return (
    <dl className="grid grid-cols-1 gap-5 sm:grid-cols-3">
      {stats.map((stat, index) => (
        <StatsCard
          key={index}
          {...stat}
          showCurrency={showCurrency}
          isLoading={isLoading}
        />
      ))}
    </dl>
  );
};

export default Stats;
